export default "__VITE_PUBLIC_ASSET__f91c5fe9__"